// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"M_TheComp__5E_fi"};